import React, { forwardRef } from 'react';
import classNames from 'classnames';

import './_tabs-pills.root.scss'
import PropTypes from 'prop-types';

import { UI_NAME } from '../../../utils/config';

import { Flex } from '../../Layout';

const TabsPillsRoot = forwardRef(
  (props, ref) => {
    const { style } = props;
    return (
      <Flex
        gap={4}
        wrap="wrap"
        style={style}
        className={classNames(`${UI_NAME}-tabs-pills`, props.className)}
        ref={ref}
      >
        {props.children}
      </Flex>
    )
  },
)

TabsPillsRoot.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  style: PropTypes.object,
}

export default TabsPillsRoot
